var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#73BE2F;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.08984,8.21533c-0.27148-0.47119-0.66504-0.86426-1.1416-1.14014l-7.39258-4.22363 c-0.94531-0.54736-2.17139-0.54395-3.10889-0.00244L5.04639,7.07764c-0.47217,0.27295-0.86572,0.6665-1.13818,1.1377 c-0.27246,0.4712-0.41749,1.00927-0.41798,1.55614v8.45312c0.00049,0.54492,0.14502,1.08301,0.41846,1.55566 c0.27295,0.47168,0.66602,0.86426,1.14209,1.13965l7.39209,4.22461c0.47168,0.27246,1.00977,0.41602,1.55664,0.41602 c0.54639,0,1.08447-0.14355,1.55225-0.41406l7.40137-4.22949c0.4707-0.27246,0.86426-0.66602,1.1377-1.1377 c0.27148-0.4707,0.41699-1.00781,0.41797-1.55273c0-0.00098,0-0.00195,0-0.00293V9.76904 C24.50781,9.22314,24.3623,8.68604,24.08984,8.21533z M13.44287,4.58301c0.16895-0.09717,0.36133-0.14893,0.55664-0.14893 c0.19482,0,0.38721,0.05176,0.56006,0.15137l6.90826,3.94702l-2.70782,1.56641l-7.45105-4.29651L13.44287,4.58301z  M13.99902,12.85303L6.53058,8.5329l2.76758-1.58148l7.46295,4.30383L13.99902,12.85303z M6.04736,19.18652 c-0.16895-0.09863-0.31006-0.23926-0.40771-0.40723c-0.09717-0.16895-0.14893-0.36133-0.14941-0.55566v-7.98206L13,14.58563v8.57367 L6.04736,19.18652z M22.35938,18.77832c-0.09766,0.16895-0.23926,0.31055-0.40332,0.40527L15,23.1582v-8.57367l7.50879-4.34326 v7.97943C22.50781,18.41699,22.45605,18.61035,22.35938,18.77832z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices6);
export default __webpack_public_path__ + "static/media/services6.dd90b79d7a0958a630a2846abdae388b.svg";
export { ForwardRef as ReactComponent };